export default "__VITE_PUBLIC_ASSET__0900c511__"